// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAD7LBhe3A1gG4kmSOvtjulCfTXkj4qd2s",
    authDomain: "eastfort-ad642.firebaseapp.com",
    projectId: "eastfort-ad642",
    storageBucket: "eastfort-ad642.firebasestorage.app",
    messagingSenderId: "24105392206",
    appId: "1:24105392206:web:70bf912975965cd971cb1f",
    measurementId: "G-M27SPSD157"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;